<template>
  <!-- Begin Page Content -->
  <div class="container" v-if="store">
    <!-- Page Heading -->
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">{{store.name}}</h1>
    </div>
    
    <div class="row justify-content-center">
      <div class="col col-md-3 col-sm-6 my-3">
        <div class="card" style="cursor:pointer;" v-bind:class="[selectedCategory==null ? 'bg-success text-white':'']" @click="getCategoryItems(null)">
          <div class="card-body" >
            <p class="card-text">Бүгд <span v-if="store && store.numberOfItems"> ({{store.numberOfItems}})</span></p>
          </div>
        </div>
      </div>
      <div class="col col-md-3 col-sm-6 my-3"  v-for="category in categories">
        <div class="card" style="cursor:pointer;" v-bind:class="[selectedCategory && selectedCategory==category.id ? 'bg-success text-white':'']" @click="getCategoryItems(category.id)">
          <div class="card-body">
            <p class="card-text">{{category.name}} <span>{{getCategoryCount(category.id)}}</span></p>
          </div>
        </div>
      </div>
    </div>
    <hr/>
    <div class="text-center text-primary text-lg">
      <p v-if="parent && parent.numberOfItems">Нийт {{parent.numberOfItems}} сэлбэг</p>
    </div>

    <div class="row my-5">
      <div class="col col-12 my-3" v-for="(item, index) in items">
        <div class="card">
          <div class="card-body">
            <p  class="font-weight-bold text-dark text-lg" v-if="item.shortCategory">
              <span v-if="item.shortCategory.category">{{item.shortCategory.category}}</span>
              <span v-if="item.shortCategory.type">/{{item.shortCategory.type}}</span>
              <span v-if="item.shortCategory.subtype">/{{item.shortCategory.subtype}}</span>

            </p>
            <div class="d-flex ">
              <img style="border-radius:5%;height:160px;" v-if="_getImage(item)" :src="_getImage(item)" alt="">
              <div class="mx-3  flex-fill ">
                <p class="font-weight-bold">{{index+1}}. {{item.name}}</p>

                <p  class="" v-if="item.shortCarType">
                  <span v-if="item.shortCarType.cartype">{{item.shortCarType.cartype}}</span>
                  <span v-if="item.shortCarType.carmark">/{{item.shortCarType.carmark}}</span>
                  <span v-if="item.shortCarType.aral">/{{item.shortCarType.aral}}</span>
                  <span v-if="item.shortCarType.caryear">/{{item.shortCarType.caryear}}</span>
                  <span v-if="item.shortCarType.carmodel">/{{item.shortCarType.carmodel}}</span>

                </p>
                <div class="row  justify-content-between">
                  <div class="col col-md-6 col-sm-12">
                    <div v-if="item.storeData">
                      <span  class="text-primary font-weight-bold"  v-if="item.storeData.name">{{item.storeData.name}}</span>
                      <br/>
                      <p  class="" v-if="item.storeData.shortAddress">
                        <span v-if="item.storeData.shortAddress.city">{{item.storeData.shortAddress.city}}</span>
                        <span v-if="item.storeData.shortAddress.district">/{{item.storeData.shortAddress.district}}</span>
                        <span v-if="item.storeData.shortAddress.horoo">/{{item.storeData.shortAddress.horoo}}</span>
                        <span v-if="item.storeData.address">/{{item.storeData.address}}</span>

                      </p>
                      
                      
                    </div>
                  </div>
                  <div  class="col col-md-6 col-sm-12">
                    <div  style="text-align:end">
                      <span class="badge badge-success" v-if="item.mount==true">Суурилуулалттай</span>
                      <span  class="badge badge-danger" v-else>Суурилуулалтгүй</span>
                    </div>
                    <div  style="text-align:end">
                      <span class="badge badge-success" v-if="item.shipping==true">Хүргэлттэй</span>
                      <span  class="badge badge-danger" v-else>Хүргэлтгүй</span>
                    </div>
                  </div>
                  
                </div>
              </div>

            </div>
            
          </div>
        </div>
      </div>
      <div class="col" v-if="end!=true">
        <button @click.prevent="getItems" class="btn btn-success btn-sm btn-block">Цааш нь үзэх</button>
      </div>
    </div>

    
  </div>
  <!-- /.container-fluid -->
</template>

<script>
const fb = require('../../firebaseConfig.js');
import Vue from 'vue';
import { mapState } from 'vuex';
export default {
  name: "CategoryItems",
  data() {
    return {
      parent:null,
      categories:[],
      items:[],
      firstVisible:null,
      lastVisible:null,
      end:false,
      store:null,
      selectedCategory:null,
      categorycounts:[]
    };
  },
  methods: {
    getCategories(){
      fb.db.collection("stores").doc(this.storeId).get().then(storeDoc=>{
        if(storeDoc && storeDoc.exists){
          let tmpStore=storeDoc.data();
          tmpStore.id=storeDoc.id;
          this.store=tmpStore;
          storeDoc.ref.collection("categorycount").get().then(docs=>{
   
            if(docs && !docs.empty){
              this.categorycounts=[];
              docs.docs.forEach(value=>{
                let item=value.data();
                item.id=value.id;
                this.categorycounts.push(item);
              })
            }

          });
          fb.db.collection("selbegtypes").orderBy("createdAt").get().then(docs=>{
            if(docs && !docs.empty){
              this.categories=[];
              docs.docs.forEach(value=>{
                if(value && value.exists){
                  let item=value.data();
                  item.id=value.id;
                  this.categories.push(item);
                }
              });
            }
          });
          this.getItems();
        }
      });
      
    },
    async getItems(){
      if(this.store && this.store.id){

        if(this.end!=true){
          var querySnapshot;
          var first=false;
          if(this.lastVisible==null){
            var query=fb.db.collection("stores").doc(this.storeId).collection("selbeg");
            if(this.selectedCategory!=undefined && this.selectedCategory!=null){
              query=query.where("category", "==", fb.db.collection("selbegtypes").doc(this.selectedCategory));
            }
            query=query.where("active", "==", true).orderBy("createdAt", "desc").limit(30);
            querySnapshot=await query
            .get();
            if(querySnapshot!=null && !querySnapshot.empty){
              this.firstVisible=querySnapshot.docs[0];
              first=true;
            }
          }
          else{
            var query=fb.db.collection("stores").doc(this.storeId).collection("selbeg");
            if(this.selectedCategory!=undefined && this.selectedCategory!=null){
              query=query.where("category", "==", fb.db.collection("selbegtypes").doc(this.selectedCategory));
            }
            query=query.where("active", "==", true)
            .startAfter(this.lastVisible)
            .limit(30);
            querySnapshot=await query.get();
          }
          
          if(querySnapshot!=null && !querySnapshot.empty){

            if(first==true || ( first!=null && this.firstVisible.id!=null && this.firstVisible.id!=querySnapshot.docs[0].id)){
              // console.log("abc");
              for(const itemDoc of querySnapshot.docs){
                let item=itemDoc.data();
                item.id=itemDoc.id;
                item.storeData=null;
                if(item.store){
                  item.store.get().then(storeDoc=>{
                    if(storeDoc && storeDoc.exists){
                      item.storeData=storeDoc.data();
                    }
                  })
                }
                // console.log(item);
                this.items.push(item);
              }
              this.lastVisible=querySnapshot.docs[querySnapshot.docs.length-1];
            }
            else
              this.end=true;
            
          }
        }
      }
    },
    getCategoryItems(categoryId){
      this.items=[];
      this.selectedCategory=categoryId;
      this.firstVisible=null;
      this.lastVisible=null;
      this.end=false;
      this.getItems();
    },
    getCategoryCount(categoryId){
      var result="";
      if(categoryId && this.categorycounts && this.categorycounts.length>0){
        for(const tmp of this.categorycounts){
          if(tmp && tmp.id && tmp.id==categoryId && tmp.count){
            result=" ("+tmp.count+") ";
          }
        }
      }
      return result;
    },
    _getImage(obj) {
      if (obj.images != null && obj.images != undefined) {

        return obj.images[0]["fileUrl"];
      }
      return null;
    },
  },
  props:{
    storeId: {
      required: true
    }
  },
  created(){
    this.getCategories();
  }
};
</script>

